

export const DashboardPath = "/dashboard";

export default function Dashboard() {

    return (
        <div style={{padding: '16px'}}>
            <h1 style={{fontFamily: "Ink", textAlign: "center", padding: "20px"}}>Call Attempts</h1>
            <iframe
                width="100%"
                height="100%"
                src="https://ap-southeast-2.quicksight.aws.amazon.com/sn/embed/share/accounts/318127875176/dashboards/422d02f1-7b90-4dc0-9410-26ee580ba275?directory_alias=nectr-dashboard">
            </iframe>
        </div>
    )
}